import React from 'react';
import { HyperdbForm } from '../../../../hyperdb';
import { Form } from '../components';

export default HyperdbForm(Form, {
  namespace: 'owner',
  mountedUrl: '/owners',
  titleNew: 'Create new owner',
  titleEdit: 'Edit owner',
  displayName: (object) => object.name,
  checkIsValid: (props) => {
    const entity = props.objectData.entity_data;
    if (!entity) return false;
    return !!entity.first_name && !!entity.last_name && !!entity.primary_email && !!entity.primary_phone;
  },
  onSubmit: (props) => {
    const objectData = props.objectData;
    const id = props.params.id;
    props.api.owner.submitOwner({ objectData, id });
  }
});



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/owner/containers/Form.jsx